// extracted by mini-css-extract-plugin
module.exports = {"blog-content":"blog-content_blog-content__D_d6l","blog-content__header":"blog-content_blog-content__header__sht1E","blog-content__img":"blog-content_blog-content__img__d3xnT"};